<template>
    <div>
  <router-view />
  <div class="q-pa-md">
    <div class="q-pa-md q-gutter-sm">
      <q-breadcrumbs>
        <q-breadcrumbs-el icon="home" to="/home" />
        <q-breadcrumbs-el
          label="Price Tracker"
          icon="widgets"
          to="/pricewatch"
        />
        <q-breadcrumbs-el
          label="Products"
          icon="navigation"
          to="/pricewatch/products"
        />
      </q-breadcrumbs>
    </div>
    </div>

    <div id="q-app" style="min-height: 100vh;">
  <div class="q-pa-md">
    <q-table
      title="Treats"
      :columns="columns"
      row-key="name"
      hide-header
      hide-bottom
    ></q-table>
  </div>
</div>
</div>
</template>
<script>
   export default{
     data(){
       return{
      columns:[
        {
          name:'title',
          required:true,
          label:'',
          field:'title',
          align:'left'
        },
        {
          name:'inp',
          required:true,
          label:'',
          field:'inp',
          align:'left'
        },
      ],
    }
     }

   }
</script>
    
    
    